import { useTranslation } from 'react-i18next';
import { useUserRoles } from '@anytag/auth';
import { FormAction } from '@anytag/shared-types';
import { TextField } from '@anytag/shared-molecules';
import { BaseModal, Form, ModalBody, ModalFooter } from '@anytag/shared-atoms';
import { EngagementBulkEditSchema } from './schema';
import { EngagementBulkEditFormKeys, EngagementBulkEditFormValues } from './types';

interface BulkEditModalProps {
  open?: boolean;
  currency?: string;
  onClose?: () => void;
  hasAdAgencyMarginRate?: boolean;
  onSubmit?: FormAction<EngagementBulkEditFormValues>['onSubmit'];
}

export const BulkEditModal = ({
  open,
  onClose,
  onSubmit,
  currency = '',
  hasAdAgencyMarginRate
}: BulkEditModalProps) => {
  const { t } = useTranslation();
  const { isAdminStaffTalentAgencyPartner } = useUserRoles();

  const currencyElement = currency ? (
    <Form.Field className="w-max flex-none self-end pl-0!">
      <p className="text-sm text-black-60">{currency}</p>
    </Form.Field>
  ) : null;

  return (
    <BaseModal open={open} onClose={onClose} title={t('Dialog.Bulk Edit')} asChild>
      <Form.Provider<EngagementBulkEditFormValues>
        onSubmit={onSubmit}
        zodSchema={EngagementBulkEditSchema}
        defaultValues={{ netBudget: '', influencerCost: '' }}
      >
        {({ formState, values }) => (
          <>
            <ModalBody>
              <Form.Fields>
                <TextField<EngagementBulkEditFormKeys>
                  type="number"
                  name="netBudget"
                  placeholder="0"
                  title={t(hasAdAgencyMarginRate ? 'TextForm.Net Budget' : 'TextForm.Budget')}
                />
                {currencyElement}

                {isAdminStaffTalentAgencyPartner ? (
                  <>
                    <TextField<EngagementBulkEditFormKeys>
                      type="number"
                      placeholder="0"
                      name="influencerCost"
                      title={t('TextForm.Influencer Cost')}
                    />
                    {currencyElement}
                  </>
                ) : null}
              </Form.Fields>
            </ModalBody>

            <ModalFooter
              cancelButton={{ onClick: onClose }}
              submitButton={{
                type: 'submit',
                title: t('Button.Apply'),
                disabled: !values.netBudget,
                loading: formState.isSubmitting
              }}
            />
          </>
        )}
      </Form.Provider>
    </BaseModal>
  );
};

export * from './types';
